module.exports = __webpack_public_path__ + "static/img/Featuresul_bg.5bc9d30.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imges/liveroadcast/Featuresul_bg.png
// module id = 253r
// module chunks = 1